export default {
    selectBdDictionary:
        "/gateway/manageBedrock/bdDictionarycs/selectBdDictionary",
};



// WEBPACK FOOTER //
// ./src/gradeDescription/api.js